import { fromPromise } from 'xstate';
import { UnauthenticateSuccessEvent, AuthMachineContext } from '../types';
import { AuthTransport, resolveAuthHeaders } from '../transport';

export type UnauthenticateInput = {
  endpoint: {
    client: AuthMachineContext['endpoints']['logout'];
  };
  /** Host-supplied header injection — see `../transport`. */
  transport?: AuthTransport;
};

export type UnauthenticateResponse = {
  success: boolean;
  message?: string;
  accessToken?: string;
};

// export type UnauthenticateOutput = {
//   type: string;
//   accessToken: string;
// };

/** @todo pass locale for auth server? */
export const unauthenticate = fromPromise<
  UnauthenticateSuccessEvent,
  UnauthenticateInput
>(async ({ input }) => {
  if (!input.endpoint.client || input.endpoint.client === '') {
    console.log('unauthenticate: No client endpoint provided.');
    throw new Error('No client endpoint provided.');
  }

  try {
    await fetch(input.endpoint.client, {
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
      headers: resolveAuthHeaders(input.transport, 'logout'),
      // headers: {
      //   'Access-Control-Allow-Origin': 'https://pwa-demo.rmgmedia.com',
      //   'Access-Control-Allow-Credentials': 'true',
      // },
    });

    return { type: 'UNAUTHENTICATE_SUCCESS' };
  } catch (err) {
    console.log(err);
    throw new Error('Could not complete unauthenticate request (server)');
  }
  /** @todo do we need to handle different status codes here...like what if the service is down? */
  // const data = await response.json();
});

export default unauthenticate;
